<template>
  <div class="app">
    <div class="allContainer">
      <p-header
        :is-login="isLogin"
        :path="path"
        v-if="headerEnable"
      />
      <template v-if="isGettedAgreedTermsInfo">
        <div class="Content">
          <app-view/>
        </div>
      </template>
      <footer-list
        :is-login="isLogin"
        :is-home="isHome"
        v-if="footerEnable"
      />
      <global-navigation
        :is-login="isLogin"
        v-if="footerEnable"/>
      <!-- <lazy-component>
        <div class="sega">
          <img src="../assets/Png/Common/SegaLogo.png">
        </div>
        <div class="footer">
          <div>&copy;SEGA All rights reserved</div>
        </div>
      </lazy-component> -->
    </div>

    <v-overlay :value="isConnecting">
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-overlay>
  </div>
</template>

<script>
import Protobuf from './mixins/protobuf';
import PHeader from './components/PHeader'
import FooterList from './components/FooterList'
import GlobalNavigation from './components/GlobalNavigation'
const pb = require('./assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: 'App',
  components: {
    PHeader,
    FooterList,
    GlobalNavigation,
  },
  mixins: [Protobuf],
  data () {
    return {
      headerHeight: 45,
      footerMinHeight: 301 + 55 // footer + gnav
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
    isHome() {
      return this.path === '/'
    },
    isConnecting() {
      return this.$store.state.isConnecting
    },
    isGettedAgreedTermsInfo() {
      return this.$store.state.isGettedAgreedTermsInfo
    },
    path() {
      return this.$route.path
    },
    screenLargeLength () {
      const h = window.innerHeight
      const w = window.innerWidth
      return h > w ? h : w
    },
    headerEnable() {
      return !(this.$route.meta && this.$route.meta.headerDisabled);
    },
    footerEnable() {
      return !(this.$route.meta && this.$route.meta.footerDisabled || this.$store.state.isMentenance)
    }
  },
  watch: {
    '$route'(newRoute, oldRoute){
      if(this.isLogin && newRoute.path !== oldRoute.path){
        this.getAgreedTermsInfo().then(res => {
          this.getTermsOfServiceNo().then(res2 => {

            this.checkAgreedTerms(res.intInformation, res2.termsOfServiceNo, newRoute.path)
          }).catch(() => {
            this.$store.state.isGettedAgreedTermsInfo = true
            this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
          })
        }).catch(() => {
          this.$store.state.isGettedAgreedTermsInfo = true
          this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
        })
      }
    }
  },
  methods: {
    // 最新の利用規約情報を取得
    async getTermsOfServiceNo() {
      const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
      const message = pb.KumaMasterSettingReq.create()
      const encoded = pb.KumaMasterSettingReq.encode(message).finish()
      return await this.post(cmdNo, encoded)
    },
    // ユーザーが最後に同意した利用規約情報を取得(informationId:1で利用規約情報を取得)
    async getAgreedTermsInfo() {
      const cmdNo = pb.PlayerGeneralInformationReq.CommandNo.COMMAND_NO
      const message = pb.PlayerGeneralInformationReq.create({
        informationId: 1,
        isSave: false,
      })
      const encoded = pb.PlayerGeneralInformationReq.encode(message).finish()
      return await this.post(cmdNo, encoded)
    },
    /***
     * 最新の利用規約に同意済みか判定
     * @param intInformation 最後に同意した利用規約番号
     * @param termsOfServiceNo 最新の利用規約番号
     */
    checkAgreedTerms(intInformation, termsOfServiceNo, path){
      if(termsOfServiceNo === intInformation){
        // 利用規約同意済み
        localStorage.setItem('isAgreedTerms', false);
      } else if(termsOfServiceNo !== intInformation && (path === '/' || path === '/terms' || path === '/Tutorial')){
        // 利用規約同意してない
        localStorage.setItem('isAgreedTerms', true);
      } else {
        // 利用規約同意してない
        localStorage.setItem('isAgreedTerms', true);
        // 強制的にトップページへ
        if(this.path !== '/') this.$router.push('/')
      }
      this.$store.state.isGettedAgreedTermsInfo = true
    }
  },
  created(){
    if(this.isLogin){
      this.$store.state.isGettedAgreedTermsInfo = false
      // 初期表示時に利用規約同意状況を確認
      this.getAgreedTermsInfo().then(res => {
        this.getTermsOfServiceNo().then(res2 => {
          this.checkAgreedTerms(res.intInformation, res2.termsOfServiceNo, this.path)
        }).catch(() => {
          this.$store.state.isGettedAgreedTermsInfo = true
          this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
        })
      }).catch(() => {
        this.$store.state.isGettedAgreedTermsInfo = true
        this.$_error('Error', { title: 'ログインで登録', statusCode: 400 })
      })
    } else {
      this.$store.state.isGettedAgreedTermsInfo = true
    }
  },
  mounted() {
    this.$store.dispatch('generateSequenceNumber')
  }
}
</script>

<style lang="scss" scoped>
.app {
  @media screen and (min-width:376px){
    &::before {
      content: "";
      display: block;
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: #fff;
      background-image:
        url(./assets/Png/Common/pnd_pc_logo.png),
        url(./assets/Png/Common/pnd_pc.jpg);
      background-position: 80px center, center top;
      background-repeat: no-repeat;
    }
  }
}
.allContainer {
    margin: auto;
    width: 375px;
    overflow: hidden;
    font-family: 'Noto Sans JP','Yu Gothic','Hiragino Kaku Gothic ProN','Meiryo',sans-serif;
  @media screen and (min-width:376px){
    position: relative;
    z-index: 1;
  }
}
.Header {
  position: fixed;
  width: 375px;
  z-index: 50;
}
.Content {
  background-color: #FBFCFD;
  margin-top: 45px;
  padding-bottom: 40px;
  min-height: calc(100vh - 320px);
}
.sega {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 49px;
}
.sega img {
  height: 27px;
  width: 83px;
}
.footer {
  align-items: center;
  background: #5e5e5e;
  color: white;
  display: flex;
  font-size: 10px;
  height: 22px;
  justify-content: center;
}
</style>
